(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["scheduleEditorMode"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["scheduleEditorMode"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__91112__, __WEBPACK_EXTERNAL_MODULE__98528__, __WEBPACK_EXTERNAL_MODULE__16056__) => {
return 